import { Header } from '@components/_ui/Header'
import { Main } from '@components/Main'
import { PriceProvider } from '@context/priceContext'
import { StepsProvider } from '@context/stepsContext'

import s from './App.module.scss'

function App() {
  return (
    <div className={s.wrapper}>
      <Header />
      <StepsProvider>
        <PriceProvider>
          <Main />
        </PriceProvider>
      </StepsProvider>
    </div>
  )
}

export default App
